import { useEmployee } from "@hooks/crud/useEmployee";
import { EmployeeLineItem } from "@interfaces/employee";
import * as RouteHelper from "@utils/routes";
import { PageBreadcrumbs } from "@stories/atoms/PageBreadcrumbs/PageBreadcrumbs";
import { useProjectContext } from "@hooks/context/useProjectContext";
import { useProfileContext } from "@hooks/context/useProfileContext";
import { EmployeeSheet } from "@stories/organisms/EmployeeSheet/EmployeeSheet";
import { Loader } from "@stories/atoms/Loaders/Loader/Loader";
import { StyledCard } from "@stories/atoms/StyledCard/StyledCard";
import { Grid } from "@mui/material";
import { StyledButton } from "@stories/atoms/StyledButton/StyledButton";
import CloudSyncIcon from "@mui/icons-material/CloudSync";
export const Employees = () => {
  const { userProfile, userOrganisation } = useProfileContext();

  if (!userOrganisation) {
    throw Error("No user organisation");
  }

  const { selectedProject, selectedProjectOrganisation } = useProjectContext();

  const { employees, isEmployeeLoading, deleteEmployees, upsertEmployees } =
    useEmployee(userProfile?.organisationId);

  const handleUpsertEmployees = (employees: EmployeeLineItem[]) => {
    upsertEmployees(employees);
  };

  const handleDeleteEmployees = (employee: EmployeeLineItem[]) => {
    deleteEmployees(employee);
  };

  const breadcrumbs = [
    {
      path: RouteHelper.contractorDashboard(selectedProject.id),
      name: `${selectedProject.projectName} Employees`,
    },
  ];

  const handleOpen = () => {
    console.log("Not implemented");
  };
  return (
    <>
      <PageBreadcrumbs
        title={`${selectedProject.projectName} Employees`}
        organisationLogo={selectedProjectOrganisation.organisationLogo}
        links={breadcrumbs}
      />

      <StyledCard>
        <Grid container spacing={2} sx={{ padding: "20px" }}>
          <Grid
            item
            xs={12}
            md={12}
            sx={{
              display: "flex",
              alignContent: "right",
              justifyContent: "right",
              margin: "auto",
            }}
            justifyContent={"right"}
          >
            <StyledButton
              variant="contained"
              startIcon={<CloudSyncIcon />}
              onClick={handleOpen}
            >
              Import Employees
            </StyledButton>
          </Grid>
          <Grid item xs={12} md={12}>
            {employees ? (
              <EmployeeSheet
                project={selectedProject}
                contractor={userOrganisation}
                employees={employees}
                loading={isEmployeeLoading}
                handleUpsertEmployees={handleUpsertEmployees}
                handleDeleteEmployees={handleDeleteEmployees}
              />
            ) : (
              <Loader />
            )}
          </Grid>
        </Grid>
      </StyledCard>
    </>
  );
};
